import React from "react";
import PropTypes from "prop-types";

import formatDuration from "@/utils/formatDuration";

const CallGrid = ({ paginatedData }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full p-4">
      {paginatedData.map((call) => (
        <div
          key={call.id}
          className="border rounded-xl p-4 shadow-lg bg-white"
        >
          {/* Header Section */}
          <div className="flex justify-between items-center bg-gray-50 shadow-[inset_0_-1px_5px_rgba(10,10,10,0.1)] p-1 rounded-full">
            <p className="text-sm font-bold text-gray-600 ml-1">{call.reference}</p>
            {['missed', 'expired'].includes(call.status?.toLowerCase()) ? (
              <span className="px-2 py-1 text-xs font-bold rounded-full bg-red-100 text-red-600">Missed</span>
            ) : call.status?.toLowerCase() === 'completed' ? (
              <span className="px-2 py-1 text-xs font-bold rounded-full bg-green-100 text-green-700">Completed</span>
            ) : (
              <span className="px-2 py-1 text-xs font-bold rounded-full bg-gray-100 text-gray-700">{call.status?.charAt(0).toUpperCase() + call.status?.slice(1)}</span>
            )}
          </div>

          {/* User Info */}
          <div className="flex items-center mt-4">
            <div className="p-1 border-orange-400 border rounded-full">
              {call.image ? (
                <img src={call.image} alt={call.name} className="w-12 h-12 rounded-full object-cover border-2 border-orange-400" />
              ) : (
                <div className="w-12 h-12 flex items-center justify-center bg-orange-300 text-white font-bold rounded-full">
                  {call.name
                    .split(" ")
                    .map((n) => n[0])
                    .join("")}
                </div>
              )}
            </div>
            <div className="ml-4">
              <h3 className="text-lg font-semibold text-orange-500">{call.name}</h3>
              <p className="text-sm text-gray-500">
                <strong className="text-orange-500">Type:</strong> {call.type}
              </p>
              <p className="text-sm text-gray-500">
                <strong className="text-orange-500">Mode:</strong> {call.mode}
              </p>
            </div>
          </div>

          {/* Details */}
          <div className="flex justify-evenly mt-4 text-gray-600 text-sm rounded-3xl shadow-[inset_0_-1px_5px_rgba(10,10,10,0.1)] py-2 px-5">
            <div className="border-r border-gray-300 pr-5">
              <p className="font-bold text-lg text-red-600">{formatDuration(call.duration)}</p>
              <p>Duration</p>
            </div>
            <div className="border-r border-gray-300 pr-5">
              <p className="font-bold text-lg">₹{call.rate || 0}</p>
              <p>Rate/Min</p>
            </div>
            <div>
              <p className="font-bold text-lg">₹{Math.ceil((call.duration || 0) / 60) * (call.rate || 0)}</p>
              <p>Earning</p>
            </div>
          </div>

          {/* Actions */}
          <div className="mt-4 flex justify-between">
            <button className="px-4 py-2 text-sm font-bold hover:bg-gray-300 rounded-full bg-gray-100">
              View Details
            </button>
            <button className="px-4 py-2 text-sm font-bold text-white bg-orange-600 hover:bg-orange-700 rounded-full">
              Start Consultation
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

CallGrid.propTypes = {
  paginatedData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      reference: PropTypes.string,
      type: PropTypes.string,
      mode: PropTypes.string,
      date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
      status: PropTypes.string,
      duration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
};

export default CallGrid;
